import logo from './logo.svg';
import './App.css';

import { WscWebGL } from '../src/WscWebGL/wsc-webgl'

//import { getAuth, onAuthStateChanged, setPersistence, browserLocalPersistence } from "firebase/auth";
//import { app } from "./firebase";
//import { getAuth, onAuthStateChanged, setPersistence, browserLocalPersistence } from "firebase/auth";
import { app } from "./firebase";

//{WscWebGL()}

//c:\projektek\React\WscWebGL\wsc-webgl-app\src\WscWebGL\TestFiles\v1_160\TemplateData\

function App() {

  var exhibitionId = "EVXC0HIQ2K8M";
  var backgroundImg = "https://onlineviewingroom.com/wp-content/uploads/2021/03/EVXC0HIQ2K8M-5.jpg";
  var wsc_webgl_folder = "WebGLApplications/WaltersCubeWebGL/v1_179/";
  var wsc_webgl_data = "WaltersCubeWebGL.data.unityweb";
  var wsc_webgl_code = "WaltersCubeWebGL.wasm.unityweb";
  var wsc_webgl_framework = "WaltersCubeWebGL.framework.js.unityweb";
  var wsc_webgl_loader = "WaltersCubeWebGL.loader.js";
  //var wsc_webgl_folder = "WebGLApplications/TestFlixJavascript/v1_002/";
  //var wsc_webgl_data = "TestFlixJavascript.data.unityweb";
  //var wsc_webgl_code = "TestFlixJavascript.wasm.unityweb";
  //var wsc_webgl_framework = "TestFlixJavascript.framework.js.unityweb";
  //var wsc_webgl_loader = "TestFlixJavascript.loader.js";

  var exhibition = 
  {
    exhibitionId: 'EVXC0HIQ2K8M',
    deepLink: 'https://link.walterscube.com/grDcutHi2Vb',
    exhibitionTitle: 'Test Artwork Look',
    galleryName: 'Gal Name',
    galleryCity: 'Gal City',
    artists: 'Peet, mMegvalaki',
    curator: 'Curi',

    backgroundImg: '',

    editorGalleryName: '',
    editorGalleryCity: '',
    editorExhibitionTitle: ''
  };

  var webGLAppsDataStr = '{"WebGLApplications":{"WaltersCubeModularEditor":{"CodeFile":"WaltersCubeModularEditor.wasm.unityweb","DataFile":"WaltersCubeModularEditor.data.unityweb","Folder":"WebGLApplications/WaltersCubeModularEditor/v1_86/","FrameworkFile":"WaltersCubeModularEditor.framework.js.unityweb","LoaderFile":"WaltersCubeModularEditor.loader.js"},"WaltersCubeModularEditorBeta":{"CodeFile":"WaltersCubeModularEditorBeta.wasm.unityweb","DataFile":"WaltersCubeModularEditorBeta.data.unityweb","Folder":"WebGLApplications/WaltersCubeModularEditorBeta/v1_86/","FrameworkFile":"WaltersCubeModularEditorBeta.framework.js.unityweb","LoaderFile":"WaltersCubeModularEditorBeta.loader.js"},"WaltersCubeModularEditorDev":{"CodeFile":"WaltersCubeModularEditorDev.wasm.unityweb","DataFile":"WaltersCubeModularEditorDev.data.unityweb","Folder":"WebGLApplications/WaltersCubeModularEditorDev/v1_86/","FrameworkFile":"WaltersCubeModularEditorDev.framework.js.unityweb","LoaderFile":"WaltersCubeModularEditorDev.loader.js"},"WaltersCubeWebGL":{"CodeFile":"WaltersCubeWebGL.wasm.unityweb","DataFile":"WaltersCubeWebGL.data.unityweb","Folder":"WebGLApplications/WaltersCubeWebGL/v1_179/","FrameworkFile":"WaltersCubeWebGL.framework.js.unityweb","LoaderFile":"WaltersCubeWebGL.loader.js"},"WaltersCubeWebGLAlpha":{"CodeFile":"WaltersCubeWebGLAlpha.wasm.unityweb","DataFile":"WaltersCubeWebGLAlpha.data.unityweb","Folder":"WebGLApplications/WaltersCubeWebGLAlpha/v1_179/","FrameworkFile":"WaltersCubeWebGLAlpha.framework.js.unityweb","LoaderFile":"WaltersCubeWebGLAlpha.loader.js"},"WaltersCubeWebGLBeta":{"CodeFile":"WaltersCubeWebGLBeta.wasm.unityweb","DataFile":"WaltersCubeWebGLBeta.data.unityweb","Folder":"WebGLApplications/WaltersCubeWebGLBeta/v1_179/","FrameworkFile":"WaltersCubeWebGLBeta.framework.js.unityweb","LoaderFile":"WaltersCubeWebGLBeta.loader.js"},"WaltersCubeWebGLDev":{"CodeFile":"WaltersCubeWebGLDev.wasm.unityweb","DataFile":"WaltersCubeWebGLDev.data.unityweb","Folder":"WebGLApplications/WaltersCubeWebGLDev/v1_179/","FrameworkFile":"WaltersCubeWebGLDev.framework.js.unityweb","LoaderFile":"WaltersCubeWebGLDev.loader.js"},"WaltersCubeWebGLMobile":{"CodeFile":"1d051b80290cf49d6a8aec1b58e82da2.wasm.unityweb","DataFile":"c9cf70f2f201e0e3edaf433a6eb801e2.data.unityweb","Folder":"WebGLApplications/WaltersCubeWebGLMobile/v1_1/","FrameworkFile":"48ddb06811a4c231a36346c12ffc8d54.js.unityweb","LoaderFile":"8eacc0d8292af0490b67dc4735c010c1.js"}},"Domain":"https://peet.walterscube.com","FooterOpenText":"Open on peet.walterscube.com","TemplateFiles":{"BackgroundImg":"background.png","CoverLogoImg":"coverLogo.png","FullScreenImg":"fullscreen.png","LogoImg":"homeIcon.png","LogoImgSmall":"homeIconSmall.png","PlayAppImg":"playApp.png","PlayHoverImg":"playHover.png","PlayImg":"play.png","SpinnerImg":"spinner.gif"}}';
  var webGLAppsData = JSON.parse(webGLAppsDataStr);

  //console.log(webGLAppsData);

  var webGLSettings = 
  {
    editor: false,
    autoPlay: false,
    embed: false,
    notExhibition: false,
    mobileWebgl: false,
    dev: false
  };

  //{WscWebGL(wsc_webgl_folder, wsc_webgl_data, wsc_webgl_code, wsc_webgl_framework, wsc_webgl_loader, exhibitionId, backgroundImg)}

  return (
    <div className="App">
      <h1>Hello React.</h1>
      <div style={{width: 960 + 'px', height: 540 + 'px', margin: 'auto'}}>
        {WscWebGL(webGLAppsData, exhibition, webGLSettings)}
      </div>
      <h2>Start editing to see some magic happen!</h2>
    </div>
  );
}

export default App;
